import React from "react";
// Customizable Area Start
import {
  Box,
  Button,
  styled,
  AppBar,
  Tabs,
  Tab,
  TextareaAutosize,
  FormControlLabel,
  Dialog,
  Select,
  CircularProgress,
  Divider,
  DialogContent,
  DialogActions,
  Snackbar,
} from "@material-ui/core";
import { Autocomplete, Alert } from "@material-ui/lab";

import { DatePicker } from "@material-ui/pickers";
import {
  createTheme,
  ThemeProvider,
  withStyles,
} from "@material-ui/core/styles";
import {
  iconCheckBox,
  iconCheckBoxChecked,
  MinusIcon,
  PlusIcon,
  productAddIcon,
} from "./assets";

import PageContainer from "../../../blocks/navigationmenu/src/PageContainer.web";
import { IUserContext } from "../../../blocks/navigationmenu/src/PageContainerController.web";
import Print from "../../print/src/Print.web";

import AutocompleteSelect from "../../../components/src/AutocompleteSelect.web";

import { colors } from "../../utilities/src/Colors";
import CatalogueCard from "../../../blocks/catalogue/src/CatalogueStoreCard.web";
import StoreCart, {
  MainButton,
} from "../../../blocks/AljabrStoreCart/src/StoreCart.web";
import { CatalogueCardSkeleton } from "../../../components/src/customComponents/CatalogueCardSkeleton.web";
import { CatalogueList } from "../../../components/src/Interface";
import { StyledTextField } from "../../../components/src/customComponents/CustomTags.web";
import { renderBaseOnConditions } from "../../../blocks/utilities/src/CustomBlockHelpers";
import {
  TextLabel,
  ErrorLabel,
} from "../../promocodes/src/PromoCodeCreate.web";
import { CustomMenuProps } from "../../ProductDescription/src/HomeCleaningSettingsList.web";
import PreferenceItem from "../../../components/src/customComponents/PreferenceItem.web";
import CarpetAndFurnitureProductDialogue from "../../../components/src/commonComponents/CarpetAndFurnitureProductDialogue";
import EditPreference from "../../../blocks/ProductDescription/src/EditPreference.web";

const muiStyle = {
  muiIcon: { padding: "4px" },
  muiCheckIcon: { position: "relative" as const, top: "4px" },
};

const theme = createTheme({
  typography: {
    fontFamily: "Montserrat",
  },
  props: {
    MuiCheckbox: {
      icon: <img src={iconCheckBox} style={muiStyle.muiIcon} />,
      checkedIcon: (
        <img src={iconCheckBoxChecked} style={muiStyle.muiCheckIcon} />
      ),
    },
  },
});
const productType = {
  NORMAL: "noraml",
  SUBPRODUCT: "Sub-Product",
  PARENT: "Parent",
};

import AljabrStoreController, {
  IFormValues,
  Props,
  configJSON,
} from "./AljabrStore2Controller.web";
import { ICartProductItem, validationSchemaForAddProduct } from "./utils";
import { CustomSnackbar } from "../../../components/src/customComponents/CustomSnackbar.web";
import SameProductDifferentServiceModal from "../../../components/src/customComponents/SameProductDifferentServiceModal.web";
import { Formik, FormikErrors, FormikProps } from "formik";
import AddProductModal from "../../../blocks/catalogue/src/AddProductModal.web";
import CustomLoader from "../../../components/src/customComponents/CustomLoader.web";

export default class AljabrStore extends AljabrStoreController {
  constructor(props: Props) {
    super(props);
  }

  // Customizable Area Start
  renderAfterPermissionComponent() {
    const { userData, storeList } = this.state;
    const dropDownId =
      userData?.attributes?.employee_proifle?.data?.attributes?.store_management
        ?.store_id;

    return (
      <div className='branchDropDown'>
        <AutocompleteSelect
          data-test-id='branchDropDown'
          placeholder='Select branch'
          fieldName={"branch"}
          options={storeList}
          value={String(dropDownId)}
          disableClear={true}
          onChange={(_event: React.ChangeEvent, value: { id: number }) => {
            this.handleStoreChange();
            this.updateEmployeeCurrentStore(value.id);
          }}
          handleScroll={this.handelStoreDropdownScroll.bind(this)}
          debouncedFunction={this.debouncedStoreSearch}
          onBlur={() => this.debouncedStoreSearch("")}
          listBoxStyle={{ maxHeight: 310 }}
        />
      </div>
    );
  }

  renderProductsList = () => {
    return (
      <CatalogueScrollBox
        onScroll={this.handleCatalogueListScroll}
        data-test-id='catalogueCardScroll'
      >
        <CatalogProductGrid>
          {this.state.cataloguesList?.map((catalogue) => {
            const catalogueId = catalogue.attributes.id;
            let selectedProductData =
              this.getCatalogueDataBasedOnCondition(catalogueId);
            let selectedProductQuantity = 0;
            if (catalogue) {
              selectedProductQuantity =
                this.state.cartProducts
                  ?.filter(
                    (product: ICartProductItem) =>
                      product.catalogue_id === catalogueId
                  )
                  ?.reduce(
                    (accu: number, product: { quantity: number }) =>
                      accu + product.quantity,
                    0
                  ) || 0;
            } else {
              selectedProductQuantity = selectedProductData?.quantity || 0;
            }
            return (
              <CatalogueCard
                navigation={this.props.navigation}
                data-test-id='product-card-component'
                key={catalogue.id}
                id='catalogueCard'
                tabsId={this.state.tabsId}
                catalogue={catalogue}
                selectedProductQuantity={
                  this.state.selectedProductQuantity[catalogue.id] || 0
                }
                addQuantityClickHandler={this.addQuantityClickHandler}
                removeQuantityClickHandler={this.removeQuantityClickHandler}
                serviceClickHandler={this.serviceClickHandler}
                parentProductId={this.state.clickedParentCatalougeId}
                isQuickDrop={this.state.isQuickDrop}
                selectedCustomer={this.state.selectedCustomer}
                resetAllProductQuantities={this.resetAllProductQuantities}
              />
            );
          })}
        </CatalogProductGrid>
      </CatalogueScrollBox>
    );
  };
 
  renderCart = () => {
    const { selectedMainTab } = this.state;
    return (
      <StoreCart
        navigation={this.props.navigation}
        id={"shoppingcart"}
        currentUser={this.state.userData}
        selectedMainTab={selectedMainTab}
        resetAllProductQuantities={this.resetAllProductQuantities}
      />
    );
  };

  getMainOrderTypeAppBar() {
    const { selectedMainTab } = this.state;
    return (
      <StyledMainAppBar position='static' data-test-id='main-order-type-tabs'>
        <Tabs
          variant='scrollable'
          scrollButtons='on'
          value={selectedMainTab}
          // onChange={(_event: React.ChangeEvent<{}>, value: string) =>
          //   this.onSendAction(Actions.CHANGE_MAIN_TAB, value)
          // }
        >
          {this.getOrderTypeList().map(({ label, value }) => (
            <Tab label={label} value={value} key={"order-type-item-" + value} />
          ))}
        </Tabs>
      </StyledMainAppBar>
    );
  }


  returnErrorSnackBar() {
    const { errorSnackbarOpen, errorMessage, snackbarSeverity } = this.state;
    return (
      <CustomSnackbar
        data-test-id='custom-errror-snackbar'
        open={errorSnackbarOpen}
        onClose={() => this.handleSnackbarClose()}
        errorMessage={errorMessage}
        autoHideDuration={3000}
        severity={snackbarSeverity}
        hideIcon={true}
      />
    );
  }

  render() {
    // Customizable Area Start
    const {
      preferenceModalVisible,
      errorSnackbarOpen,
      sameProductDifferentServiceModalVisible,
      isEditPreferencesPopupOpen,
      permissionStatus,
    } = this.state;

    return (
      // Customizable Area Start
      <MainWrapper>
        <ThemeProvider theme={theme}>
          <CustomLoader loading={this.state.isLoading} />

          {permissionStatus.createPermission && (
            <Box style={{ height: "100%" }}>
              <CataloguesFlex style={{ height: "100%" }}>
                <CatalogueVflexBox>
                  {this.getMainOrderTypeAppBar()}
                  {this.getOrderRenderBasedOnOrderType(
                    <>
                      <h1>{configJSON.homeCleaningFacilityText}</h1>
                    </>,
                    <>
                      <StyledAppBar position='static'>
                        <Tabs
                          value={this.state.tabsId}
                          onChange={this.tabSectionChangeHandler}
                          scrollButtons='on'
                          variant='scrollable'
                          indicatorColor='primary'
                          textColor='primary'
                        >
                          <Tab
                            label='Golden Points'
                            value={0}
                            key='static-tab'
                            className='highlightSection'
                          />
                        </Tabs>
                      </StyledAppBar>

                      {this.renderProductsList()}
                    </>
                  )}
                </CatalogueVflexBox>
                {this.renderCart()}
              </CataloguesFlex>
            </Box>
          )}
          {!permissionStatus.createPermission && (
            <Snackbar
              anchorOrigin={{
                vertical: "top",
                horizontal: "center",
              }}
              open={!permissionStatus.createPermission}
            >
              <Alert severity='warning'>{configJSON.permissionMessage}</Alert>
            </Snackbar>
          )}
        </ThemeProvider>
        {errorSnackbarOpen && this.returnErrorSnackBar()}
      </MainWrapper>
      // Customizable Area End
    );
  }
}

// Customizable Area Start
const CataloguesFlex = styled(Box)({
  display: "flex",
  gap: "20px",
  flex: "1 1 0",
  padding: "0 0 16px 0",
  justifyContent: "space-between",
});

const CatalogueVflexBox = styled(Box)({
  flex: "1 1 0",
  display: "flex",
  flexDirection: "column",
  maxWidth: "calc(100% - 420px)",
  "@media only screen and (max-width: 1280px)": {
    maxWidth: "calc(100% - 380px)",
  },
  "@media only screen and (max-width: 1024px)": {
    maxWidth: "calc(100% - 340px)",
  },
});

const CatalogueScrollBox = styled(Box)({
  flex: "1 1 0",
  overflow: "auto",
});


const MainWrapper = styled("div")({
  fontFamily: "Montserrat",
  height: "100%",
  "& .mb-24": {
    marginBottom: "24px",
  },
  "& .buttonWrapper": {
    minWidth: "100px",
    display: "flex",
    justifyContent: "space-evenly",
    alignItems: "center",
  },
  "& .branchDropDown": {
    minWidth: "200px",
    margin: "0 12px",
  },
  "& .font-600": { fontWeight: 600 },
  "& .mr-8": { marginRight: 8 },
  "&. .qtyNum": { padding: "0 10px" },
  "& .w-full-80": { width: "80%" },
  "& .cursor-pointer": { cursor: "pointer" },
  "& .customerButton": {
    padding: 0,
    backgroundColor: "#204B9C",
    minWidth: "36px",
    height: "36px",
    borderRadius: "8px",
  },
  "& .cartPaymentOption": {
    marginTop: "24px",
    marginBottom: 0,
  },
  "& .mobileBlock": {
    display: "flex",
    justifyContent: "space-berween",
  },
  "& .cartSubtotalWrapper": {
    display: "flex",
    width: "100%",
    cursor: "pointer",
  },
  "& .cartTotalWrapper": {
    backgroundColor: "#EC4E20",
    borderRadius: "8px",
    padding: "16px 24px",
    color: "#FFF",
    marginTop: "20px",
  },
  "& .backInner": {
    width: "100%",
    display: "flex",
  },
  "& .cartSubtotalPrice": {
    marginLeft: "auto",
    fontWeight: 600,
  },
  "& .cartTotalListPrice": {
    fontWeight: 400,
    marginLeft: "auto",
    marginRight: "25px",
  },
  "& .countryInput": {
    width: "72px",
    marginRight: "12px",
    padding: 0,
  },
  "& .countryInput .MuiOutlinedInput-input": {
    padding: 10,
  },
  "& .phone-number .MuiAutocomplete-inputRoot": {
    padding: 1,
  },
  "& .phone-number .MuiInputBase-input": {
    fontSize: "14px",
    fontWeight: 500,
  },
  "& .deleteIcon": {
    cursor: "pointer",
    width: "16px",
    height: "16px",
  },
  "& .dialogTitle": {
    margin: "auto",
    paddingTop: "32px",
    paddingBottom: "24px",
  },
  "& .dialogActionWrapper": {
    justifyContent: "center",
    paddingTop: "24px",
    paddingBottom: "32px",
  },
  "& .cartItemQuantityIcon": {
    cursor: "pointer",
    width: "16px",
    height: "16px",
    color: "white",
  },
  "& .emptyCartIcon": {
    width: "93px",
    height: "74px",
  },
  "& .cartProductNote": {
    width: "100%",
    padding: "8px",
    maxWidth: "100%",
    borderRadius: "8px",
    border: "1px solid #ECECEC",
  },
  "& .sideCart": {
    padding: "16px",
    borderRadius: "8px",
    border: "1px solid #ECECEC",
  },
  "& .cartItemContainer": {
    borderRadius: "12px",
    boxShadow: "0px 2px 4px 4px rgba(0, 0, 0, 0.08)",
    padding: "20px 16px",
  },
  "& .editAllBtn": {
    padding: "8px 10px",
    borderRadius: "8px",
    background: "rgba(32, 75, 156, 0.10)",
    color: "#204B9C",
    cursor: "pointer",
    fontSize: "13px",
    fontWeight: 600,
  },
  "& .cartHeaderContainer": {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  "& .cartProductDetailPrice": {
    color: "#4D4D4D",
    fontSize: "12px",
    fontWeight: 500,
    letterSpacing: "-0.35px",
    opacity: 0.6,
  },
  "& .cartProductQuantityContainerMain": {
    maxWidth: "81px",
    flex: "0 0 81px",
    padding: "10px 8px",
  },
  "& .cartProductQuantityContainer": {
    height: "30px",
    borderRadius: "7px",
    background: "#EC4E20",
    color: "#FFF",
    textAlign: "center" as const,
    lineHeight: "30px",
  },
  "& .selectDataLabel": {
    color: colors().black,
    fontWeight: 600,
    fontSize: 14,
  },
  "& .cartProductDetailTotal": {
    color: colors().viewTextColor,
    fontSize: "14px",
    fontWeight: 400,
    whiteSpace: "nowrap" as const,
    display: "flex",
    gap: "8px",
    alignItems: "center",
  },
  "& .cartProductQuantityContainerSecond": {
    height: "30px",
    borderRadius: "7px",
    background: "#EC4E20",
    color: "#FFF",
    textAlign: "center" as const,
    lineHeight: "30px",
    minWidth: "95px",
    padding: "0 8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  "& .cartProductDetailContainer": {
    display: "flex",
    flexDirection: "column" as const,
    margin: "0 8px 0 0",
    alignSelf: "baseline",
  },
  "& .mainCartDetailConatiner": {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "start",
  },
  "& .cartLeftSection": {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  "& .cartRightSection": {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },
  "& .cartProductDetailContainerMain": {
    flex: "2",
    padding: "10px 0px",
  },
  "& .clearAllBtnContainer": {
    display: "flex",
    justifyContent: "flex-end",
  },
  "& .greyPoint": {
    backgroundColor: "#DEDEDE",
    width: 6,
    height: 6,
    borderRadius: "50%",
    marginLeft: 8,
    marginRight: 8,
  },
  "& .cartProductImgWrapperMain": {
    maxWidth: "70px",
    flex: "0 0 70px",
    padding: "10px 8px",
  },
  "& .cartProductDetailTitle": {
    display: "flex",
    alignItems: "center",
    marginRight: "12px",
  },
  "& .productNameTitle": {
    color: colors().darkjunglegreen,
    fontSize: "14px",
    fontWeight: 600,
    whiteSpace: "nowrap" as const,
  },
  "& .upchargeTitle": {
    color: colors().darkliver,
    fontSize: "12px",
    fontWeight: 500,
    whiteSpace: "nowrap" as const,
  },
  "& .dateSelectWrapper": {
    padding: "16px 0",
    display: "flex",
    gap: "16px",
    "@media only screen and (max-width:1024px)": {
      flexDirection: "column",
    },
  },
  "& .cartProductImg": {
    width: "100%",
    height: "100%",
  },
  "& .cartProductImgWrapper": {
    width: "100%",
    borderRadius: "8px",
    border: "1px solid #ECECEC",
    height: "54px",
  },
  "& .cartProductContainer": {
    display: "flex",
    alignItems: "center",
    marginBottom: "24px",
  },
  "& .clearAllBtn": {
    color: "#ec4e20",
    borderBottom: "1px solid #ec4e20",
    cursor: "pointer",
    marginTop: 16,
    fontWeight: 600,
  },
  "& .cartServiceTitle": {
    color: colors().cyancobaltblue,
    fontSize: "14px",
    fontWeight: 600,
    lineheight: "18px",
    marginTop: "24px",
  },
  "& .emptyCartWrapper": {
    display: "flex",
    flexDirection: "column" as const,
    alignItems: "center",
  },
  "& .cartProductsContainer": {
    overflowY: "auto" as const,
    maxHeight: 540,
  },
  "& .addProductBtnText": {
    color: "#204B9C",
    fontSize: 13,
    fontWeight: 600,
    marginTop: 8,
    "@media only screen and (max-width: 1024px)": {
      fontSize: 10,
    },
  },
  "& .cartTotalList": {
    display: "flex",
    width: "100%",
    marginBottom: "16px",
  },
  "& .addProductBtnPlus": {
    fontSize: 40,
    color: "#204B9C",
    fontWeight: 400,
  },
  "& .addProductBtnPlusContainer": {
    width: 48,
    height: 48,
    display: "flex",
    background: "#D4DDEC",
    justifyContent: "center",
    borderRadius: 8,
    alignItems: "center",
  },
  "& cartTotalListWrapper": {
    marginBottom: "20px",
  },
  "& .productsPage": {
    paddingRight: "32px",
    paddingTop: "56px",
    paddingLeft: "48px",
  },
  "& .dialogProducts": {
    display: "flex",
    flexWrap: "wrap" as const,
    gap: "18px",
    justifyContent: "space-evenly" as const,
  },
  "& .productsListContainer": {
    display: "grid",
    gridGap: "32px",
    gridTemplateColumns:
      "minmax(192px, 1fr) minmax(192px, 1fr) minmax(192px, 1fr)",
    "@media only screen and (min-width:1024px)": {
      gridGap: "16px",
      gridTemplateColumns: "minmax(128px, 1fr) minmax(128px, 1fr)",
    },
    "@media only screen and (min-width:1280px)": {
      gridGap: "16px",
      gridTemplateColumns: "minmax(128px, 1fr) minmax(128px, 1fr)",
    },
    "@media only screen and (max-width:800px)": {
      gridGap: "16px",
      gridTemplateColumns: "minmax(128px, 1fr) minmax(128px, 1fr)",
    },
    "@media only screen and (min-width:1400px)": {
      gridGap: "24px",
      gridTemplateColumns:
        "minmax(128px, 1fr) minmax(128px, 1fr) minmax(128px, 1fr) minmax(128px, 1fr)",
    },
  },
  "& .addProductBtnContainer": {
    height: "179px",
    width: "105px",
    borderRadius: 8,
    background: "#E8EDF5",
    display: "flex" as const,
    flexDirection: "column" as const,
    justifyContent: "center" as const,
    alignItems: "center",
    cursor: "pointer",
    "@media only screen and (max-width: 1280px)": {
      width: "95px",
    },
    "@media only screen and (max-width: 1024px)": {
      width: "75px",
    },
  },
  "& .ftWeight400": {
    fontWeight: 400,
  },
  "& .ftWeight600": {
    fontWeight: 600,
  },
});

const PaginationContainer = styled("div")({
  display: "flex",
  padding: "32px 0px",
  justifyContent: "flex-end",
});

const CatalogProductGrid = styled("div")({
  flexWrap: "wrap",
  gap: "25px",
  display: "grid",
  gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
  padding: "16px",
  width: "100%",
  boxSizing: "border-box",
  "@media (max-width: 1024px)": {
    gridTemplateColumns: "repeat(auto-fill, minmax(180px, 1fr))",
    gap: "12px",
  },
});

const StyledAppBar = withStyles({
  root: {
    color: colors().darkliver,
    margin: "24px 0",
    backgroundColor: colors().white,
    borderBottom: `1px solid ${colors().lightborder}`,
    boxShadow: "none",
    "& .MuiTab-root": {
      textTransform: "none",
      maxWidth: "unset",
      fontSize: 18,
      minWidth: "fit-content",
      "@media only screen and (max-width: 1024px)": {
        fontSize: 16,
      },
    },
    "& .MuiTabs-flexContainer": {
      // justifyContent: "space-between"
    },
    "& .Mui-selected": {
      color: colors().cyancobaltblue,
      fontWeight: 700,
    },
    "& .MuiTabs-indicator": {
      backgroundColor: `${colors().cyancobaltblue} !important`,
    },
    "& .MuiPaper-elevation": {
      boxShadow: "none",
    },
    "& .highlightSection": {
      backgroundColor: "lightgrey",
      borderBottom: "3px solid blue",
    },
  },
})(AppBar);

const StyledMainAppBar = withStyles({
  root: {
    margin: 0,
    "& .MuiTab-root": {
      textTransform: "none",
      maxWidth: "unset",
      fontSize: 20,
      marginRight: "30px",
      "@media only screen and (max-width: 1024px)": {
        fontSize: 18,
      },
      "@media only screen and (max-width: 768px)": {
        fontSize: 16,
      },
    },
  },
})(StyledAppBar);

// Customizable Area End
